import { Col, Row, notification, Modal, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { baseUrl, revert } from "../dasboard";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import dayjs from "dayjs";

import {
  getUserInfo,
  handleError,
  saveTableInfo,
  saveUserInfo,
  saveToken,
  saveStreamToken,
  saveStreamInfo,
  clearAuth,
} from "../../hooks/useHttp";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { StreamApiClient } from "../../services/streamService";

import QrReader from "react-qr-scanner";
const formatTime = (timestamp) => {
  return dayjs(timestamp).format("HH:mm:ss, DD/MM/YYYY");
};


function LoginPage() {

  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [inputTableId, setInputTableId] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const locale = useSelector((state) => state.users.locale);
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
  const [openQr, setOpenQr] = useState(false);
  const [isHttps, setIsHttps] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [createTableModalOpen, setCreateTableModalOpen] = useState(false);
  const [withChicken, setWithChicken] = useState(false);
  const [customTableName, setCustomTableName] = useState("");
  const [streamQrOpen, setStreamQrOpen] = useState(false);
  const [streamIsLive, setStreamIsLive] = useState(false);
  const [streamLoading, setStreamLoading] = useState(false);
  const [editUsernameModalOpen, setEditUsernameModalOpen] = useState(false);
  const [newUsername, setNewUsername] = useState("");
  const [editUsernameLoading, setEditUsernameLoading] = useState(false);
console.warn("----- LoginPage rendered -----");
  //test scanner area react-qr-scanner////
  useEffect(() => {
    const currentLocation = window.location.href;

    // setIsHttps(currentLocation.split(":")[0] === "https" ? true : false);
// console.log("currentLocation", currentLocation.split(":")[1]);
    if (currentLocation.split(":")[0] === "https" ) {
      setIsHttps(true);
    }
    if (currentLocation.split(":")[0] === "http") {
      if (currentLocation.split(":")[1] === "//localhost") {
        setIsHttps(true);
      } else {
        setIsHttps(false);
      }
    }
  }, []);

  const delay = 300;

  const previewStyle = { height: 240, width: 320 };

  const getTableIdFromQrText = (text) => {
    const rawText = text?.trim();
    if (!rawText) return "";

    try {
      const qrUrl = new URL(rawText, window.location.origin);
      const pathParts = qrUrl.pathname.split("/").filter(Boolean);
      return pathParts[pathParts.length - 1] || "";
    } catch (error) {
      const pathParts = rawText.split(/[/?#]/).filter(Boolean);
      return pathParts[pathParts.length - 1] || "";
    }
  };

  const handlerScanWebcam = async (result) => {
    if (result) {
      setOpenQr(false);

      const qrTableId = getTableIdFromQrText(result?.text);
      if (!qrTableId) {
        notification.error({
          message: formatMessage({ id: "error.invalidQrCode" }),
          placement: "top",
        });
        return;
      }

      await joinTableHandler(qrTableId);
    }
  };

  const handlerScanCodeError = (err) => {
    console.log("err", err);
    navigate("/");
  };

  // Stream QR scan handler - checks for existing stream or creates new one
  const handleStreamQrScan = async (result) => {
    if (result) {
      setStreamQrOpen(false);
      const qrTableId = getTableIdFromQrText(result?.text);
      if (!qrTableId) {
        notification.error({
          message: formatMessage({ id: "error.invalidQrCode" }),
          placement: "top",
        });
        return;
      }
      
      setStreamLoading(true);
      try {
        const apiClient = new StreamApiClient();
        let streamId = null;
        
        // Step 1: Check if table already has a stream_id
        try {
          const tableResponse = await fetch(`${baseUrl}/tables/${qrTableId}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (tableResponse.ok) {
            const tableData = await tableResponse.json();
            if (tableData.streamId) {
              streamId = tableData.streamId;
              console.log('[Login] Found existing stream_id:', streamId);
            }
          }
        } catch (e) {
          console.log('[Login] Could not fetch table, will create new stream');
        }
        
        // Step 2: If no existing stream, create new one
        if (!streamId) {
          const createResponse = await apiClient.createStream(qrTableId);
          streamId = createResponse.stream_id;
          console.log('[Login] Created new stream:', streamId);
          
          // Save stream_id to backend
          try {
            await fetch(`${baseUrl}/tables/${qrTableId}/stream-id`, {
              method: 'PUT',
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}` 
              },
              body: JSON.stringify({ streamId: streamId })
            });
            console.log('[Login] Saved stream_id to backend');
          } catch (e) {
            console.warn('[Login] Could not save stream_id to backend:', e);
          }
        }
        
        // Step 3: Activate stream (set is_live = true)
        const activateResponse = await apiClient.activateStream(streamId);
        console.log('[Login] Stream activated:', activateResponse);
        
        // Check if is_live is true
        if (activateResponse.is_live === true) {
          setStreamIsLive(true);
          notification.success({
            message: 'Stream Activated',
            description: 'Stream is now live!',
            placement: 'top',
          });
          
          // Navigate to broadcast page with stream info
          navigate(`/stream/broadcast/${qrTableId}`, {
            state: { 
              streamId: streamId,
              isLive: true 
            }
          });
        } else {
          notification.warning({
            message: 'Stream Not Live',
            description: 'Stream was created but not activated.',
            placement: 'top',
          });
        }
      } catch (error) {
        console.error('[Login] Failed to create/activate stream:', error);
        notification.error({
          message: 'Stream Failed',
          description: error.message,
          placement: 'top',
        });
      } finally {
        setStreamLoading(false);
      }
    }
  };
  ///////////////end test area//////////////////

  useEffect(() => {
    const currentuser = getUserInfo();
    console.log("--------------- currentuser -----------------", currentuser);
    if (currentuser) {
      setIsLoggedIn(true);
      setUserName(currentuser.username);
    }
  }, []);

  const onUserEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const onUserNameChange = (e) => {
    setUserName(e.target.value);
  };

  const onPasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const onConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const joinTableHandler = async (tableId) => {
    if (!tableId) {
      notification.error({
        message: formatMessage({ id: "error.invalidQrCode" }),
        placement: "top",
      });
      return;
    }

    const currentUser = getUserInfo();
    const token = localStorage.getItem("token");

    if (!currentUser?.id || !token) {
      localStorage.setItem("pendingTableId", tableId);
      notification.info({
        message: "Please log in to join a table",
        placement: "top",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(
        `${baseUrl}/tables/${tableId}/players`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId: currentUser.id }),
        }
      );

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        saveTableInfo(tableId);
        navigate(`/${tableId}`);
        return;
      }

      notification.error({
        message: data.error || data.message || "Failed to join table",
        placement: "top",
      });
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const openCreateTableModal = () => {
    const date = Date.now();
    const defaultTableName = `${userName}'s Table ${date}`;
    setCustomTableName(defaultTableName);
    setWithChicken(false); // Reset về false mỗi lần mở modal
    setCreateTableModalOpen(true);
  };

  const onCreateTable = async () => {
    try {
      setCreateTableModalOpen(false);
      setIsLoading(true);
      
      // Sử dụng tên bàn tùy chỉnh hoặc tạo một tên mặc định nếu rỗng
      const tableName = customTableName || `${userName}'s Table ${Date.now()}`;
      

      let createTableUrl = withChicken 
        ? `${baseUrl}/tables/with-chicken` 
        : `${baseUrl}/tables`;
     
      const res = await fetch(createTableUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ tableName: tableName }),
      });
      
      if (res.status === 201) {
        const data = await res.json();
        if (data && data.id) {
          // Mark as table creator to avoid joining the table again
          localStorage.setItem("isTableCreator", "true");
          // Save the table ID and navigate directly to the table
          saveTableInfo(data.id);
          navigate(`/${data.id}`);
        }
      } else {
        const data = await res.json();
        notification.error({
          message: data.error || "Failed to create table",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const registerHandler = async () => {
    if (password !== confirmPassword) {
      notification.error({
        message: "Passwords do not match",
        placement: "top",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(`${baseUrl}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          username: userName,
          password: password,
        }),
      });

      const data = await res.json();

      if (res.status === 201) {
        notification.success({
          message: "Registration successful. You can now log in.",
          placement: "top",
        });
        setIsRegisterView(false); // Switch to login view
      } else {
        notification.error({
          message: data.error || "Registration failed",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const applyLoginResponse = async (data) => {
    saveToken(data.token);
    if (data.streamToken) {
      saveStreamToken(data.streamToken);
      saveStreamInfo({ app_name: data.app_name });
    }
    const userInfo = {
      username: data.user.username,
      id: data.user.id,
    };
    saveUserInfo(userInfo);
    setUserName(data.user.username);
    setIsLoggedIn(true);
    notification.success({
      message: "Login successful",
      placement: "top",
    });

    const pendingTableId = localStorage.getItem("pendingTableId");
    if (pendingTableId) {
      localStorage.removeItem("pendingTableId");
      try {
        await joinTableHandler(pendingTableId);
      } catch (error) {
        console.error("Failed to auto-join table:", error);
      }
    }
  };

  const loginHandler = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(`${baseUrl}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          username: userName,
          password: password,
        }),
      });

      const data = await res.json();

      if (res.status === 200 && data.token) {
        await applyLoginResponse(data);
      } else {
        notification.error({
          message: data.error || "Login failed",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const googleLoginHandler = async (credentialResponse) => {
    if (!credentialResponse?.credential) {
      notification.error({
        message: "Google login failed",
        placement: "top",
      });
      return;
    }

    try {
      setIsLoading(true);
      const res = await fetch(`${baseUrl}/auth/google`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });

      const data = await res.json();

      if (res.status === 200 && data.token) {
        await applyLoginResponse(data);
      } else {
        notification.error({
          message: data.error || "Google login failed",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const logoutHandler = () => {
    setIsLoggedIn(false);
    setUserName("");
    clearAuth();
  };

  const updateUsernameHandler = async () => {
    if (!newUsername.trim()) return;
    try {
      setEditUsernameLoading(true);
      const res = await fetch(`${baseUrl}/auth/username`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ username: newUsername.trim() }),
      });
      const data = await res.json();
      if (res.ok) {
        setUserName(data.username);
        const userInfo = getUserInfo();
        saveUserInfo({ ...userInfo, username: data.username });
        setEditUsernameModalOpen(false);
        notification.success({
          message: formatMessage({ id: "auth.usernameUpdated" }),
          placement: "top",
        });
      } else {
        notification.error({
          message: data.error || "Failed to update username",
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setEditUsernameLoading(false);
    }
  };
  
  // Hàm lấy lịch sử các bàn đã tham gia
  const fetchPlayHistory = async () => {
    try {
      setHistoryLoading(true);
      const currentUser = getUserInfo();
      if (!currentUser || !currentUser.id) {
        notification.error({
          message: `${formatMessage({ id: "error.fetchUserData" })}`,
          placement: "top",
        });
        return;
      }
      
      const res = await fetch(`${baseUrl}/players/${currentUser.id}/history`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
      });
      
      const data = await res.json();
      
      if (res.ok) {
        revert(data);
        setHistoryData(data);
        setHistoryModalOpen(true);
      } else {
        notification.error({
          message: data.error || `${formatMessage({ id: "error.fetchPlayerHistoryData" })}`,
          placement: "top",
        });
      }
    } catch (e) {
      handleError(e);
    } finally {
      setHistoryLoading(false);
    }
  };

  const [isRegisterView, setIsRegisterView] = useState(false);

  return (
    <div className={isLoggedIn ? "" : "auth-container"}>
      <Row style={{ width: '100%' }}>
        {!isLoggedIn && (
          <Col span={24}>
            {/* Starfield Background */}
            <div className="auth-starfield">
              {[...Array(30)].map((_, i) => (
                <div key={i} className={`auth-star auth-star-${i}`} />
              ))}
            </div>

            {/* Header */}
            <div className="auth-screen-header">
              <div className="auth-logo">
                <img src={require('../../assets/logo512.png')} alt="Bip Score" />
              </div>
              <h1 className="auth-app-name">Bip Score</h1>
              <button className="auth-lang-btn" onClick={() => {
                const event = new CustomEvent('toggleLanguage');
                window.dispatchEvent(event);
              }}>
                <span>🌐</span> {locale === 'vi_VN' ? 'VIE' : 'ENG'}
              </button>
            </div>

            {/* Main Content */}
            <div className="auth-content">
              <h2 className="auth-main-title">
                {isRegisterView
                  ? formatMessage({ id: "auth.mainTitle.register" })
                  : formatMessage({ id: "auth.mainTitle.login" })
                }
              </h2>
              <p className="auth-hero-subtitle">
                {formatMessage({ id: "auth.heroSubtitle" })}
              </p>

              {/* Auth Card */}
              <div className="auth-card-wrapper">
                <div className="auth-card">
                  {/* Login View */}
                  {!isRegisterView && (
                    <>
                      <h2 className="auth-card-title">{formatMessage({ id: "auth.welcomeTitle" })}</h2>
                      <p className="auth-card-subtitle">{formatMessage({ id: "auth.loginSubtitle" })}</p>
                      <div className="auth-form">
                        <div className="auth-field">
                          <input
                            type="email"
                            className="auth-field-input"
                            value={email}
                            onChange={onUserEmailChange}
                            placeholder={formatMessage({ id: "placeHolder.enterEmail" })}
                          />
                        </div>
                        <div className="auth-field">
                          <div className="auth-password-wrapper">
                            <input
                              type="password"
                              className="auth-field-input"
                              value={password}
                              onChange={onPasswordChange}
                              placeholder={formatMessage({ id: "placeHolder.enterPassword" })}
                              id="login-password"
                            />
                            <span className="auth-password-toggle" onClick={() => {
                              const input = document.getElementById('login-password');
                              input.type = input.type === 'password' ? 'text' : 'password';
                            }}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                            </span>
                          </div>
                        </div>
                        <button
                          className="auth-submit-btn"
                          onClick={loginHandler}
                          disabled={!email || !password || isLoading}
                        >
                          {isLoading ? '...' : formatMessage({ id: "title.login" })}
                        </button>
                        {googleClientId && (
                          <>
                            <div className="auth-google-divider">
                              <span>{formatMessage({ id: "message.or" })}</span>
                            </div>
                            <div className="auth-google-wrapper">
                              <GoogleLogin
                                onSuccess={googleLoginHandler}
                                onError={() => notification.error({ message: "Google login failed", placement: "top" })}
                                theme="filled_black"
                                shape="rectangular"
                                text="continue_with"
                                width="300"
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <p className="auth-switch-text">
                        {formatMessage({ id: "auth.noAccount" })}{' '}
                        <span className="auth-switch-link" onClick={() => setIsRegisterView(true)}>
                          {formatMessage({ id: "auth.signUp" })}
                        </span>
                      </p>
                    </>
                  )}

                  {/* Register View */}
                  {isRegisterView && (
                    <>
                      <h2 className="auth-card-title">{formatMessage({ id: "auth.registerTitle" })}</h2>
                      <p className="auth-card-subtitle">{formatMessage({ id: "auth.registerSubtitle" })}</p>
                      <div className="auth-form">
                        <div className="auth-field">
                          <input
                            type="email"
                            className="auth-field-input"
                            value={email}
                            onChange={onUserEmailChange}
                            placeholder={formatMessage({ id: "placeHolder.enterEmail" })}
                          />
                        </div>
                        <div className="auth-field">
                          <input
                            type="text"
                            className="auth-field-input"
                            value={userName}
                            onChange={onUserNameChange}
                            placeholder={formatMessage({ id: "placeHolder.enterName" })}
                          />
                        </div>
                        <div className="auth-field">
                          <div className="auth-password-wrapper">
                            <input
                              type="password"
                              className="auth-field-input"
                              value={password}
                              onChange={onPasswordChange}
                              placeholder={formatMessage({ id: "placeHolder.enterPassword" })}
                              id="register-password"
                            />
                            <span className="auth-password-toggle" onClick={() => {
                              const input = document.getElementById('register-password');
                              input.type = input.type === 'password' ? 'text' : 'password';
                            }}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                            </span>
                          </div>
                        </div>
                        <div className="auth-field">
                          <div className="auth-password-wrapper">
                            <input
                              type="password"
                              className="auth-field-input"
                              value={confirmPassword}
                              onChange={onConfirmPasswordChange}
                              placeholder={formatMessage({ id: "placeHolder.confirmPassword" })}
                              id="register-confirm-password"
                            />
                            <span className="auth-password-toggle" onClick={() => {
                              const input = document.getElementById('register-confirm-password');
                              input.type = input.type === 'password' ? 'text' : 'password';
                            }}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                            </span>
                          </div>
                        </div>
                        <button
                          className="auth-submit-btn"
                          onClick={registerHandler}
                          disabled={!email || !userName || !password || !confirmPassword || isLoading}
                        >
                          {isLoading ? '...' : formatMessage({ id: "title.register" })}
                        </button>
                      </div>
                      <p className="auth-switch-text">
                        {formatMessage({ id: "auth.haveAccount" })}{' '}
                        <span className="auth-switch-link" onClick={() => setIsRegisterView(false)}>
                          {formatMessage({ id: "auth.signIn" })}
                        </span>
                      </p>
                    </>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="auth-footer">
                <span>🔒 bip.ermis.network</span>
              </div>
            </div>
          </Col>
        )}

        {isLoggedIn && (
          <div className="welcome-container">
            {/* Welcome Header */}
            <div className="welcome-header">
              <h1 className="welcome-title">
                {formatMessage({ id: "title.welcome" })}, {userName}!
                <span
                  style={{ marginLeft: 8, cursor: 'pointer', fontSize: '18px', opacity: 0.6 }}
                  onClick={() => { setNewUsername(userName); setEditUsernameModalOpen(true); }}
                  title={formatMessage({ id: "auth.updateUsername" })}
                >✏️</span>
              </h1>
              <span className="logout-link" onClick={logoutHandler}>
                ({formatMessage({ id: "title.logout" })})
              </span>
            </div>

            {/* Subtitle */}
            <p className="welcome-subtitle">{formatMessage({ id: "message.nowYouCan" })}</p>

            {/* Action Cards */}
            <div className="action-cards-grid">
              <div className="action-card action-card-create" onClick={openCreateTableModal}>
                <span className="action-card-text">Create<br/>New Table</span>
              </div>
              <div 
                className={`action-card action-card-scan ${!isHttps ? 'disabled' : ''}`}
                onClick={() => isHttps && setOpenQr(!openQr)}
              >
                <span className="action-card-text">Scan<br/>QR Code</span>
              </div>
            </div>

            {/* QR Scanner */}
            {openQr && (
              <div className="qr-scanner-container">
                <QrReader
                  delay={delay}
                  style={previewStyle}
                  onError={handlerScanCodeError}
                  onScan={handlerScanWebcam}
                  constraints={{
                    audio: false,
                    video: { facingMode: "environment" },
                  }}
                />
              </div>
            )}

            {/* OR Divider */}
            <div className="or-divider">
              <span>OR</span>
            </div>

            {/* Table ID Input */}
            <div className="table-id-input-container">
              <input
                type="text"
                className="table-id-input"
                placeholder={formatMessage({ id: "placeHolder.enterTableId" })}
                value={inputTableId}
                onChange={(e) => setInputTableId(e.target.value)}
              />
            </div>

            {/* Stream QR Scanner */}
            {streamQrOpen && (
              <div className="qr-scanner-container">
                <QrReader
                  delay={delay}
                  style={previewStyle}
                  onError={handlerScanCodeError}
                  onScan={handleStreamQrScan}
                  constraints={{
                    audio: false,
                    video: { facingMode: "environment" },
                  }}
                />
                <button 
                  className="close-qr-button"
                  onClick={() => setStreamQrOpen(false)}
                >
                  Cancel
                </button>
              </div>
            )}

            {/* Action Buttons Row */}
            <div className="action-buttons-row">
              <button 
                className="action-button"
                onClick={() => joinTableHandler(inputTableId)}
                disabled={!inputTableId}
              >
                {formatMessage({ id: "button.joinTable" })}
              </button>
              <button 
                className={`action-button action-button-stream ${streamIsLive ? 'stream-live' : ''}`}
                onClick={() => isHttps && setStreamQrOpen(!streamQrOpen)}
                disabled={!isHttps || streamLoading}
              >
                <span className="stream-icon">{streamLoading ? '⏳' : '📹'}</span>
                {streamLoading ? 'Loading...' : (streamIsLive ? 'LIVE' : 'Live')}
              </button>
              <button 
                className="action-button"
                onClick={fetchPlayHistory}
                disabled={historyLoading}
              >
                History
              </button>
            </div>

            {/* Footer */}
            <div className="welcome-footer">
              <span>From Hoangbim with ❤️</span>
            </div>
          </div>
        )}

        {/* Modal hiển thị lịch sử bàn đã chơi */}
        <Modal
          title={null}
          open={historyModalOpen}
          onCancel={() => setHistoryModalOpen(false)}
          footer={null}
          width="100%"
          style={{ top: 0, padding: 0, maxWidth: '100vw' }}
          bodyStyle={{ padding: 0 }}
          className="history-modal"
        >
          <div className="history-container">
            <h1 className="history-title">Joined Table History</h1>
            
            {historyLoading ? (
              <div className="history-loading">Loading...</div>
            ) : historyData.length === 0 ? (
              <div className="history-empty">{formatMessage({ id: "message.notJoined" })}</div>
            ) : (
              <div className="history-cards-list">
                {[...historyData].reverse().map((item) => (
                  <div 
                    key={item.tableId}
                    className="history-card"
                    onClick={() => {
                      saveTableInfo(item.tableId);
                      navigate(`/${item.tableId}`);
                      setHistoryModalOpen(false);
                    }}
                  >
                    <div className="history-card-header">
                      <span className="history-table-name">{item.tableName}</span>
                    </div>
                    <div className="history-card-date">
                      Joined at: {formatTime(item.joinedAt)}
                    </div>
                    <div className="history-card-footer">
                      <span className={`history-points-badge ${item.currentPoints >= 0 ? 'positive' : 'negative'}`}>
                        {item.currentPoints}
                      </span>
                      {item.isCreator && (
                        <span className="history-creator-badge">
                          👤 Creator
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Modal>

        {/* Modal update username */}
        <Modal
          title={null}
          open={editUsernameModalOpen}
          onCancel={() => setEditUsernameModalOpen(false)}
          footer={null}
          className="create-table-modal"
          centered
        >
          <div className="create-table-content">
            <h2 className="create-table-title">{formatMessage({ id: "auth.updateUsername" })}</h2>
            <div className="create-table-field">
              <label className="create-table-label">{formatMessage({ id: "auth.newUsername" })}</label>
              <input
                type="text"
                className="create-table-input"
                value={newUsername}
                onChange={(e) => setNewUsername(e.target.value)}
                maxLength={50}
                onKeyDown={(e) => e.key === 'Enter' && updateUsernameHandler()}
              />
            </div>
            <div className="create-table-buttons">
              <button
                className="create-table-btn cancel-btn"
                onClick={() => setEditUsernameModalOpen(false)}
              >
                {formatMessage({ id: "button.cancel" })}
              </button>
              <button
                className="create-table-btn create-btn"
                onClick={updateUsernameHandler}
                disabled={editUsernameLoading || !newUsername.trim()}
              >
                {editUsernameLoading ? 'Saving...' : formatMessage({ id: "auth.updateUsername" })}
              </button>
            </div>
          </div>
        </Modal>

        {/* Modal tạo bàn mới */}
        <Modal
          title={null}
          open={createTableModalOpen}
          onCancel={() => setCreateTableModalOpen(false)}
          footer={null}
          className="create-table-modal"
          centered
        >
          <div className="create-table-content">
            <h2 className="create-table-title">Create new table</h2>
            
            <div className="create-table-field">
              <label className="create-table-label">Table name</label>
              <input
                type="text"
                className="create-table-input"
                value={customTableName}
                onChange={(e) => setCustomTableName(e.target.value)}
              />
              <span className="create-table-help">
                {formatMessage({ id: "title.tableHelp" })}
              </span>
            </div>

            <div className="create-table-toggle-row">
              <span className="create-table-toggle-label">
                {formatMessage({ id: "button.create-chick" })}
              </span>
              <Switch
                checked={withChicken}
                onChange={(checked) => setWithChicken(checked)}
                className="create-table-switch"
              />
            </div>

            <div className="create-table-buttons">
              <button 
                className="create-table-btn cancel-btn"
                onClick={() => setCreateTableModalOpen(false)}
              >
                {formatMessage({ id: "button.cancel" })}
              </button>
              <button 
                className="create-table-btn create-btn"
                onClick={onCreateTable}
                disabled={isLoading}
              >
                {isLoading ? 'Creating...' : 'Create new table'}
              </button>
            </div>
          </div>
        </Modal>
      </Row>
    </div>
  );
}

export default LoginPage;
